import { useTranslation } from "react-i18next";
import { EmptyState } from "@/components/empty-state";

/**
 * Any URL this app does not know, and the old `/checkoutv1/404`.
 *
 * The empty state and nothing else. No "404": a number is what a server says to another server,
 * and the person reading it wants to know which link to open instead. No object either: rule 132
 * keeps the object family off a money surface.
 */

export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <div className="bg-surface-paper px-gk-4 flex min-h-screen items-center justify-center">
      <div className="ds-reveal w-full max-w-[520px]">
        <EmptyState
          heading={t("gymkeePay.common.notFoundHeading")}
          line={t("gymkeePay.common.notFoundLine")}
          inset={false}
        />
      </div>
    </div>
  );
}
